import {CustomCellRendererProps} from '@ag-grid-community/react';
import {GeofenceEvent} from "@ots-frontend/ots-data";
import {IconRadar, IconRadarOff} from "@tabler/icons-react";

export type GeofenceEventCellValue = {
  geofenceEvent: GeofenceEvent,
  skipGeofenceEvent?: boolean
}

export type GeofenceEventCellProps = CustomCellRendererProps<GeofenceEventCellValue>

export const GeofenceEventCell = (props: GeofenceEventCellProps) => {
  const {value} = props

  if (!value || !value.geofenceEvent) {
    return undefined
  }

  return value.skipGeofenceEvent ? <IconRadarOff size={14}/> : <IconRadar size={14} />
}
